import { Injectable } from '@angular/core';

import { Tenant, UserState, Juris, ParamInfo } from './index.model';
import { English } from './languages';
import { UserRole } from './enumtype';
import { OTPModel } from '../services/otp.model';
import { EmpInfo, cspformsmodel } from '../services/index.model';
import { AdminLogin, superAdminAuthentication } from '../admin/index.model';



@Injectable()
export class SessionStorageService { 

    public userState: UserState;
    public juris: Juris;
    public tenant: Tenant;
    public paramInfo: ParamInfo[];
    public OTP: OTPModel;
    public empInfo: EmpInfo;
    public objcsp: cspformsmodel;
    public objadminLogin: superAdminAuthentication;

    constructor() { }

    // User Token
    
    public setUserState(currentUserState: UserState, isDefault?: boolean) {
        if (isDefault) {
            currentUserState.LoggedInUserRole = UserRole.Anonymous;
        }

        currentUserState.BGPath = (currentUserState.BGPath) ? currentUserState.BGPath : 'assets/img/hero.jpg';
        sessionStorage.setItem("userinfo", JSON.stringify(currentUserState));
    }
    
    public getUserState(): UserState {
        let user = sessionStorage.getItem("userinfo");
        this.userState = JSON.parse(user);
        return this.userState;
    }
    
    public getTenantId(): string {
        return this.getUserState() ? this.getUserState().TenantID : null;
    }

    public getJurisId(): string {
        return this.getUserState() ? this.getUserState().JurisID : null;
    }

    public getJurisNo(): number {
        return this.getUserState() ? this.getUserState().JurisNo : null;
    }

    public getJurisName(): string {
        return this.getUserState() ? this.getUserState().JurisName : null;
    }

    public getJurisAddress1(): string {
        return this.getUserState() ? this.getUserState().Location : null;
    }

    public getJurisAddress2(): string {
        return this.getUserState() ? this.getUserState().Address2 : null;
    }

    public getJurisCity(): string {
        return this.getUserState() ? this.getUserState().City : null;
    }

    public getJurisState(): string {
        return this.getUserState() ? this.getUserState().State : null;
    }

    public getJurisStateName(): string {
        return this.getUserState() ? this.getUserState().StateName : null;
    }

    public getJurisZip(): string {
        return this.getUserState() ? this.getUserState().Zip : null;
    }

    public getJurisPhoneNumber(): string {
        return this.getUserState() ? this.getUserState().PhoneNumber : null;
    }

    public getJurisPhoneExtension(): string {
        return this.getUserState() ? this.getUserState().PhoneExtension : null;
    }

    public getJurisFaxNumber(): string {
        return this.getUserState() ? this.getUserState().FaxNumber : null;
    }

    public getJurisFaxExtension(): string {
        return this.getUserState() ? this.getUserState().FaxExtension : null;
    }

    public getJurisLatitude(): number {
        return this.getUserState() ? this.getUserState().Latitude : null;
    }

    public getJurisLongitude(): number {
        return this.getUserState() ? this.getUserState().Longitude : null;
    }

    public getFileAttachment(): string {
        return this.getUserState() ? this.getUserState().LogoPath : null;
    }

    public getFileType(): string {
        return this.getUserState() ? this.getUserState().FileType : null;
    }

    public getUserID(): string {
        return this.getUserState() ? this.getUserState().LoggedInUserId : null;
    }

    public getUserRole(): number {
        return this.getUserState() ? this.getUserState().LoggedInUserRole : null;
    }

    public getPawn(): boolean {
        return this.getUserState() ? this.getUserState().pawnMenu : null;
    }

    public getUserName(): string {
        return this.getUserState() ? this.getUserState().UserName : null;
    }

    public getUserEmail(): string {
        return this.getUserState() ? this.getUserState().Email : null;
    }

    public getJurisEmailID(): string {
        return this.getUserState() ? this.getUserState().JurisEmail : null;
    }

    public getLang(): string {
        return this.getUserState() ? this.getUserState().Lang : null;
    }

    public getLatitude(): number {
        return this.getUserState() ? this.getUserState().Latitude : null;
    }
    public getLongitude(): number {
        return this.getUserState() ? this.getUserState().Longitude : null;
    }
    public getIsAdminRecoverPwd(): number {
        return this.getUserState() ? this.getUserState().IsRecoverPwd : null;
    }

    public getUserToken(): string {
        return this.getUserState() ? this.getUserState().Token : null;
    }

    public getUseAccessKey(): string {
        return this.getUserState() ? this.getUserState().PhoenixKey : null;
    }

    public IsParkingPermitEnabled(): boolean {
        return this.getUserState() ? this.getUserState().IsParkingPermitEnabled : false;
    }

    public IsTaxiComplaintEnabled(): boolean {
        return this.getUserState() ? this.getUserState().IsTaxicomplaintEnabled : false;
    }

    public getLogoSize(): string {
        return this.getUserState() ? this.getUserState().LogoSize : null;
    }

    public getBGFileAttachment(): string {
        return this.getUserState() ? this.getUserState().BGPath : 'assets/img/hero.jpg';
    }

    
    public getBGFileType(): string {
        return this.getUserState() ? this.getUserState().BGFileType : null;
    }

    public removeUserState() {
        sessionStorage.removeItem("userinfo");
    }
    public getRegStatus(): string {
        return this.getUserState() ? this.getUserState().RegStatus : null;
    }

    public setUserAccessKey(key: string) {
        if (this.userState) {
            this.userState.PhoenixKey = key;
            this.setUserState(this.userState);
        }
    }

    public logIn(userRole: number, userId: string, userName: string, email?: string, token?: string, pawnMenu?: boolean,regStatus?:string) {
        if (this.userState) {
            this.userState.LoggedInUserRole = userRole;
            this.userState.LoggedInUserId = userId;
            this.userState.UserName = userName;
            this.userState.Email = email;
            this.userState.Token = token;
            this.userState.pawnMenu = pawnMenu;
            this.userState.RegStatus = regStatus;
            this.setUserState(this.userState);
        }
    }

    public logOut() {
        if (this.userState) {
            this.userState.LoggedInUserRole = UserRole.Anonymous;
            this.userState.LoggedInUserId = null;
            this.userState.UserName = null;
            this.userState.Email = null;
            this.userState.Token = null;
            this.userState.pawnMenu = false;
            this.userState.RegStatus = null;
            this.setUserState(this.userState);
        }
    }

    public setLanguage(language: string) {
        if (this.userState) {
            this.userState.Lang = language;
            this.setUserState(this.userState);
        }
    }

    public setJurisDetails(juris: Juris, isBgFalse: boolean = true) {
        if (this.userState) {
            this.userState.TenantID = juris.TenantID;
            this.userState.JurisName = juris.JurisName;
            this.userState.JurisID = juris.JurisID;
            this.userState.JurisNo = juris.JurisNo;
            if (juris.LogoPath)
                this.userState.LogoPath = juris.LogoPath;
                
            this.userState.FileType = juris.FileType;
            this.userState.LogoSize = juris.LogoSize;

            this.userState.Latitude = juris.Latitude;
            this.userState.Longitude = juris.Longitude;
            this.userState.Location = juris.Location;
            this.userState.Address2 = juris.Address2;
            this.userState.City = juris.City;
            this.userState.State = juris.State;
            this.userState.StateName = juris.StateName;
            this.userState.Zip = juris.Zip;
            this.userState.ZipCode = juris.ZipCode;
            this.userState.PhoneNumber = juris.PhoneNumber;
            this.userState.JurisEmail = juris.EmailID;
            this.userState.PhoneExtension = juris.PhoneExtension;
            this.userState.FaxNumber = juris.FaxNumber;
            this.userState.FaxExtension = juris.FaxExtension;
            this.userState.IsRecoverPwd = juris.IsRecoverPwd;           
            if (isBgFalse) {
                this.userState.BGPath = (juris.BGPath) ? juris.BGPath : 'assets/img/hero.jpg';
            }

            this.userState.BGFileType = juris.BGFileType;

            this.setUserState(this.userState);
           
            let tentObject: Tenant = this.getTenantState();
            if (tentObject) {
                tentObject.Juris.map(row => row.JurisNo == this.userState.JurisNo ? row.BGPath = this.userState.BGPath : row.BGPath = row.BGPath);
                this.setTenantState(tentObject);
            }
        }
    }

    // Tenant

    public setTenantState(tenant: Tenant) {
        sessionStorage.setItem("tenant", JSON.stringify(tenant));
    }

    public getTenantState(): Tenant {
        let tenant = sessionStorage.getItem("tenant");
        if(this.tenant == null)
            this.tenant = JSON.parse(tenant);
        return this.tenant;
    }

    public setTaxiComplaintRole(isTaxiComplaint: boolean) {
        sessionStorage.setItem("taxi", JSON.stringify(isTaxiComplaint));
    }

    public getTaxiComplaintRole(): boolean {
        let isTaxiComplaint = JSON.parse(sessionStorage.getItem("taxi"));
        return isTaxiComplaint;
    }

    //public setParamInfo(paramInfo: ParamInfo[]) {
    //    sessionStorage.setItem("paramInfo", JSON.stringify(paramInfo));
    //}

    //public getParamInfo(): ParamInfo[] {
    //    let paramInfo = sessionStorage.getItem("paramInfo");
        
    //    this.paramInfo = JSON.parse(paramInfo);
    //    return this.paramInfo;
    //}

    public removeTenantState() {
        sessionStorage.removeItem("tenant");
    }

    public removeParamInfo() {
        sessionStorage.removeItem("paramInfo");
    }

    public removeAll() {
        sessionStorage.clear();
    }

    public SetOTPDetail(otp: OTPModel) {
        sessionStorage.setItem("OTP", JSON.stringify(otp));
    }

    public GetOTPDetail(): OTPModel {
        let emp = sessionStorage.getItem("OTP");
        this.OTP = JSON.parse(emp);
        return this.OTP;
    }

    public getempDetail(): EmpInfo {
        let emp = sessionStorage.getItem("empinfo");
        this.empInfo = JSON.parse(emp);
        return this.empInfo;
    }

    public setempdetail(empinfo: EmpInfo) {
        sessionStorage.setItem("empinfo", JSON.stringify(empinfo));
    }

    public getPDFUrl(): any {
        let emp = sessionStorage.getItem("urls");
        this.empInfo = JSON.parse(emp);
        return this.empInfo;
    }

    public setPDFUrl(url:any) {
        sessionStorage.setItem("urls", JSON.stringify(url));
    }  

    public getCSPFormdetails(): cspformsmodel {
        let CSPFormdetails = sessionStorage.getItem("Cspdetail");
        this.objcsp = JSON.parse(CSPFormdetails);
        return this.objcsp;
    }


    public setCSPFormdetails(Cspdetails: cspformsmodel) {
        sessionStorage.setItem("Cspdetail", JSON.stringify(Cspdetails));
    }

    public SetRequestFormUrl(url: any) {
        sessionStorage.setItem("FormsURL", JSON.stringify(url));
    } 
    public getAdminLogin(): superAdminAuthentication {
        let adminLoginDetails = sessionStorage.getItem("AdminLoginDetails");
        this.objadminLogin = JSON.parse(adminLoginDetails);
        return this.objadminLogin;
    }

    public setAdminLogin(adminlogin: superAdminAuthentication) {
        sessionStorage.setItem("AdminLoginDetails", JSON.stringify(adminlogin));
    }
    public getRequestFormUrl(): any {
        let emp = sessionStorage.getItem("FormsURL");
        this.empInfo = JSON.parse(emp);
        return this.empInfo;
    }

    public removeRequestFormUrl() {
        sessionStorage.removeItem("FormsURL");
    }

}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/sessionstorage.service.ts